const React = require("react");
const T = React.PropTypes;
const _ = require("lodash");
const UUID = require("node-uuid");

const FileSelectionActionCreators = require("../actionCreators/FileSelectionActionCreators.js");
const File = require("../types/File.js");

const SelectedFile = require("./SelectedFile.jsx");
const EmptyList = require("./EmptyList.jsx");

const styles = {
    Outer: {
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "center",
        paddingTop: 10,
        paddingLeft: "20%",
        paddingRight: "20%",
        overflow: "auto",
        margin: 20
    },
    DragOver: {
        backgroundColor: "rgba(200, 220, 200, .4)",
        border: "1px dashed"
    }
};

const SelectedFileList = React.createClass({
    propTypes: {
        style: T.object,
        Files: T.arrayOf(File.Type),
        ValidExtensions: T.shape({
            AreLoading: T.bool,
            Data: T.arrayOf(T.string),
            LoadError: T.object
        }).isRequired
    },
    getDefaultProps(){
        return {
            style: {}
        };
    },
    getInitialState() {
        return {
            IsDraggedOver: false
        };
    },
    render() {
        const overStyle = this.GetOverStyle();

        const style = Object.assign({}, styles.Outer, this.props.style, overStyle);

        let children = null;

        if((this.props.Files || []).length) {
            children = this.GetSelectedFiles();
        }
        else {
            children = this.GetEmptyMessage();
        }
        
        return (<div style={style}
                     onDragOver={this.OnDragOver}
                     onDragLeave={this.OnDragLeave}
                     onDrop={this.OnDrop}>
            {children}
        </div>);
    },
    GetSelectedFiles() {
        const fileStyle = {
            flex: "0 0 200px",
            margin: 20,
            height: 120
        };
        
        const result = this.props.Files.map((f) => {
            return (<SelectedFile key={f.UID} File={f} style={fileStyle } />);
        });

        return result;
    },
    GetEmptyMessage() {
        const emptyStyle = {
            margin: "auto"
        };
        
        return (<EmptyList style={emptyStyle} />);
    },
    OnDragOver(e) {
        e.preventDefault();

        this.setState({ IsDraggedOver: true });
    },
    OnDragLeave(e) {
        e.preventDefault();

        this.setState({ IsDraggedOver: false });
    },
    OnDrop(e) {
        e.preventDefault();

        const files = e.dataTransfer.files;
        
        for (var i = 0; i < files.length; i++) {
            const f = files[i];

            const fromUpload = File.FromUpload(f, this.props.ValidExtensions.Data);

            FileSelectionActionCreators.Add(fromUpload);
        }

        this.setState({ IsDraggedOver: false });
    },
    FileIsBanned(file) {
        return false;
    },
    GetOverStyle() {
        if (this.state.IsDraggedOver) {
            return styles.DragOver;
        }

        return {};
    }
});

module.exports = SelectedFileList;


// WEBPACK FOOTER //
// ./src/components/SelectedFileList.jsx